module.exports = __webpack_public_path__ + "static/img/医生直播@2x1.687c09c5.png";